import { useContext } from 'react';
import { JobCreationContext } from '../context/job-creation-context';

// ----------------------------------------------------------------------

export const useJobCreationContext = () => {
  const context = useContext(JobCreationContext);

  if (!context)
    throw new Error(
      'useJobCreationContext context must be use inside AuthProvider',
    );

  return context;
};
